import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import request from "../../../../../../Services/API/Requests";
import FieldScreenComponent from "../../FieldScreenComponent";
import findByString from "../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

//components
import Classifications from "./Classifications/Classifications";
import Questions from "./Questions/Questions";
import JsonScreenHoc from "../../../../../../HocHelpers/JsonScreenHoc";

const DesignMode = ({dataSource, screenName}) => {
    const [schema, setSchema] = useState();
    const globalValues = useSelector(state => state.jsonScreen.globalValues)
    const values = findByString(globalValues.param[screenName], dataSource) || {};
    useEffect(() => {
        request({
            url: "/schema/read",
            data: {
                id: "surveyParam"
            }
        }).then(res => {
            setSchema(res);
        }).catch(err => {
            console.log(err);
        })
    }, []);


    if (!schema) return <></>

    return (
        <div style={{width: '100%'}}>
            <FieldScreenComponent
                field={{
                    properties: {
                        ...schema.properties[0],
                        path: `${dataSource}.${schema.properties[0].name}`
                    },
                    styles: [{width: '250px'}, {width: "150px"}],

                }}
            />
            <FieldScreenComponent
                field={{
                    properties: {
                        ...schema.properties[1],
                        path: `${dataSource}.${schema.properties[1].name}`
                    },
                    styles: [{width: '250px'}, {width: "150px"}],
                }}
            />
            <FieldScreenComponent
                field={{
                    properties: {
                        ...schema.properties[2],
                        path: `${dataSource}.${schema.properties[2].name}`
                    },
                    styles: [{width: '250px'}, {width: "150px"}],
                }}
            />
            <Questions
                values={values}
                questions={values.questions || []}
                dataSource={dataSource}
            />
            <Classifications
                classifications={values.classification || []}
                values={values}
                dataSource={dataSource}
            />
        </div>
    )
}

export default JsonScreenHoc(DesignMode);